/**
 * Author: ligj@mapbar.com
 * Create Time: 2018/01/10 17:09
 * Description:
 */

import ssoService from './services/sso.service';
import comService from "./services/common.service";
import {setSidebarMenu} from './core'
// import menuData from "./app.menu";
export default {
    state: {
        userInfo: null,
        siteParam:{   // 权限的必填入参
            menuBar:'ITSM',
        },
        skinName:"wedof-itsm_skin",  // skin的key，项目换肤唯一标识
        isCollapse:false,
        dictionary:{},               // 全部的数据字典
        dictionary2:{},      //CICD的数据字典
        caseType:{},                // 类型id
        defuseParams: {}, // 默认应用参数
        useParams: {}, // 默认应用参数
        num:1,
        menuData:[], //动态建立左边目录时用到,
        keepAlive: '',
        waitApprove:null,//待审批人
        resourceTypeList:[], //资源类型列表
        resourceTypeAttr:[],
        myAgencyData:[]
    },
    mutations: {//commit  同步操作
        setMyAgencyData(state, params){
            state.myAgencyData = params
        },
        setUserInfo(state, userInfo){
            state.userInfo = userInfo;
        },
        setUserDetails(state, params){
            state.userDetails = params;
      	},
      	setCollapse(state, params){
            state.isCollapse = params;
        },
        setWaitApprove(state, params){
            state.waitApprove = params
        },
        setDictionary(state, params){
            state.dictionary = params;
        },
        setDictionary2(state, params){
            state.dictionary2 = params;
        },
        setCaseType(state, params){
            state.caseType = params;
        },
        setDefuseParams(state, params) {
            state.defuseParams = params;
        },
        setUseParams(state, params) {
            state.useParams = params;
        },
        setParamEnv(state, params) {
            state.useParams = {
                ...state.useParams,
                server: params.server,
                env: params.env,
                paramsTag: params.paramsTag,
                serviceTag: params.serviceTag
            }
        },
        setUserParamsServer(state) {
            state.useParams.server = []
            state.useParams.env = []
        },
        setNum(state, params){
            state.num = params;
        },
        setSideBarMenu(state,params){
            state.menuData=params
        },
       setKeepAlive: (state, keepAlive) => {
           state.keepAlive = keepAlive
        },
        setResourceType(state, params){
            state.resourceTypeList = params;
        },
        setResourceTypeAttr(state, params){
            state.resourceTypeAttr = params;
        },
    },
    actions: {//dispatch   含异步操作
        getmyAgencyData(context,params){
            console.log(context)
            console.log(params)
            context.commit('setMyAgencyData',params);
        },
        getKeepAlive(context,params){
            context.commit('setKeepAlive',params);
        },
        logout(context){
            return ssoService.logout().then(rs => {
                context.commit('setUserInfo',null);
                return true;
            });
        },
        setUserDetails(context,params){
        	context.commit('setUserDetails',params);
        },
        getWaitApprove(context,params){
            context.commit("setWaitApprove",params);
        },
        getDictionary(context,params){
            return comService.dictionary().then(res => {
                context.commit("setDictionary",res);
                return true;
            })
        },
        getResourceType(context,params){
            return comService.getResourceTypeList().then(res => {
                context.commit("setResourceType",res);
                return true;
            })
        },
        getDictionary2(context,params){
            return comService.dictionary2().then(res => {
                context.commit("setDictionary2",res);
                return true;
            })
        },
        // 分类id
        getCaseType(context,params){
            return comService.getCaseType().then(res => {
                // console.log(res,'res');
                context.commit("setCaseType",res);
                return true;
            })
        },
        // getMenuData(context,params){
        //     return comService.getMenuData().then(res=>{
        //         // console.log(res,'动态menu');
        //         context.commit('setSideBarMenu',res)
        //         setSidebarMenu(res)
        //     })
        // }
        //获取动态权限(这里只是把动态目录存在store里，动态路由在别的地方操作)
         getAuth(context,params){
            // console.log('触发store里的getAuth');
            return comService.getAuth(params).then(res=>{
                // console.log(res,'store里获取处理后的权限详情');
                context.commit('setSideBarMenu',res.menu_data)
                // console.log(this.state.menuData);
                // setSidebarMenu(this.state.menuData)
            })
        },
    },
    getters: {}
};
